module.exports = "<xo-generic-message token=token></xo-generic-message>\n<button ng-if=\"cart.isWalletTokenization()\" ng-click=\"redirect($event)\" class=\"btn full\" content>\n    {{content('memberReview.continueLabel')}}\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-generic-message/template.html
// module id = ./pages/xo-generic-message/template.html
// module chunks = 1